import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default function () {
    return {
        availableJobCategories
    }
}
